const CDN_BASE_URL = 'https://zcjb-cdn.oss-cn-shanghai.aliyuncs.com/zcjf-web/'

const createResourcePath = (basePath) => (filename) => `${CDN_BASE_URL}${basePath}${filename}`

const ResourceBasePaths = {
    loginBanner: 'login_banner/',
    kefu: 'kefu/',
    logo: 'logo/',
};

const createLoginBannerPath = createResourcePath(ResourceBasePaths.loginBanner)
const createKefuPath = createResourcePath(ResourceBasePaths.kefu)

export const CdnResource = {
    loginBanner: {
        banner_01: createLoginBannerPath('banner_01.jpeg'),
        bsgzw_banner_01: createLoginBannerPath('bsgzw_banner_01.png'),
    },
    kefu: createKefuPath('wx_qr.png'),
    logo: {
        bsgzw_logo: createResourcePath(ResourceBasePaths.logo)('bsgzw_logo.png'),
    }
}
